/**
 * resetTimeLocal.js — Convertir l'heure de reset serveur (minuit Europe/Paris)
 *   vers le timezone local de l'utilisateur.
 *
 * Pourquoi : le serveur compte les usages par jour calendaire Paris
 *   (`(NOW() AT TIME ZONE 'Europe/Paris')::date`). C'est immuable serveur-side.
 *   Mais afficher "minuit (Paris)" à un user à Moscou est trompeur — chez lui,
 *   le reset arrive à 02:00 (CET hiver) ou 01:00 (CEST été).
 *
 * Cette fonction calcule la prochaine "minuit Paris" en UTC, puis la formate
 *   dans le timezone détecté de l'utilisateur. Gère automatiquement l'heure
 *   d'été/hiver via l'API Intl (CET vs CEST).
 *
 * v1.12.571
 */

// Renvoie le Date (UTC interne) qui représente le prochain passage à 00:00 Europe/Paris.
function getNextMidnightParisUTC() {
  const now = new Date();
  // Date courante en Europe/Paris (string YYYY-MM-DD via Intl)
  const parisDateStr = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Paris',
    year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(now);
  const [y, m, d] = parisDateStr.split('-').map(Number);
  // Candidat : demain 00:00 interprété comme UTC (faux, va être corrigé)
  let candidate = new Date(Date.UTC(y, m - 1, d + 1, 0, 0, 0));
  // Combien ce candidat affiche-t-il en Paris ? Si = 1h → on est en hiver (UTC+1).
  // Si = 2h → en été (UTC+2). On recule candidat de cet offset pour obtenir
  // l'UTC instant qui correspond exactement à 00:00 Paris.
  const parisHour = parseInt(new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Paris', hour: '2-digit', hour12: false,
  }).format(candidate), 10);
  return new Date(candidate.getTime() - parisHour * 3600000);
}

// Formate la prochaine minuit Paris dans le timezone local du user.
// Retour : { localTimeStr, hoursUntil, isFR }
// Ex pour user Paris (été)   : { localTimeStr: "00:00", hoursUntil: 4 }
// Ex pour user Moscow (été)  : { localTimeStr: "01:00", hoursUntil: 5 }
export function formatNextDailyReset(lang) {
  const nextReset = getNextMidnightParisUTC();
  const now = new Date();
  const hoursUntil = Math.max(1, Math.round((nextReset - now) / 3600000));
  const localTimeStr = new Intl.DateTimeFormat(lang || 'fr-FR', {
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).format(nextReset);
  // Récupère le nom abrégé du timezone local (ex: CEST, MSK)
  let tzName = '';
  try {
    const parts = new Intl.DateTimeFormat(lang || 'fr-FR', {
      timeZoneName: 'short', hour: '2-digit',
    }).formatToParts(nextReset);
    tzName = parts.find(p => p.type === 'timeZoneName')?.value || '';
  } catch {}
  return { localTimeStr, hoursUntil, tzName };
}
